/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentCorpoDeletePmMutationVariables = {|
  corpoRef: string
|};
export type PaymentCorpoDeletePmMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
      |}
    |}
  |}
|};
export type PaymentCorpoDeletePmMutation = {|
  variables: PaymentCorpoDeletePmMutationVariables,
  response: PaymentCorpoDeletePmMutationResponse,
|};
*/


/*
mutation PaymentCorpoDeletePmMutation(
  $corpoRef: String!
) {
  payment {
    corpo {
      res: deleteSubscriptionPaymentMethod(corpoRef: $corpoRef) {
        code
        message
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpoRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "corpoRef",
                "variableName": "corpoRef"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "deleteSubscriptionPaymentMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoDeletePmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoDeletePmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99f5399dc297a1a440105f3600d36332",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoDeletePmMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoDeletePmMutation(\n  $corpoRef: String!\n) {\n  payment {\n    corpo {\n      res: deleteSubscriptionPaymentMethod(corpoRef: $corpoRef) {\n        code\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3713d55df6ff503227a740747b1dfec5';

module.exports = node;
